import { IMaster, RestaurationConfiguration } from '../IMaster';
import { IMasterSync } from '../IMasterSync';
import { P00039DataRxTxIndex, P00039Sync } from './P00039Sync';
import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00045 } from './P00045';
import { P00041 } from './P00041';
import { P00042 } from './P00042';
import { P00039InstallationFinish } from './P00039/Installation/P00039InstallationFinish';
import { P00039InstallationReset } from './P00039/Installation/P00039InstallationReset';
import { P00031 } from './P00031';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00039EclairageMiseEnOeuvreInit } from './P00039/Eclairage/miseenoeuvre/P00039EclairageMiseEnOeuvreInit';
import { P00039CardEclairageStatutComponent } from './P00039/Eclairage/cards/p00039-card-eclairage-statut/p00039-card-eclairage-statut.component';
import { P00039CardEclairageControleComponent } from './P00039/Eclairage/cards/p00039-card-eclairage-controle/p00039-card-eclairage-controle.component';
import { P00039EclairageStatusComponent } from './P00039/Eclairage/cps/p00039-eclairage-status/p00039-eclairage-status.component';
import { P00039EclairageControleComponent } from './P00039/Eclairage/cps/p00039-eclairage-controle/p00039-eclairage-controle.component';
import { P00039EclairageParametersSettingsComponent } from './P00039/Eclairage/cps/p00039-eclairage-parameters-settings/p00039-eclairage-parameters-settings.component';
import { P00039EclairageMiseEnOeuvreProgEclairageComponent } from './P00039/Eclairage/miseenoeuvre/p00039-eclairage-mise-en-oeuvre-prog-eclairage/p00039-eclairage-mise-en-oeuvre-prog-eclairage.component';
import { P00039EclairageMiseEnOeuvreAutomatismeComponent } from './P00039/Eclairage/miseenoeuvre/p00039-eclairage-mise-en-oeuvre-automatisme/p00039-eclairage-mise-en-oeuvre-automatisme.component';
import { P00039CardCouvertureStatutComponent } from './P00039/Couverture/cards/p00039-card-couverture-statut/p00039-card-couverture-statut.component';
import { P00039CardCouvertureControleComponent } from './P00039/Couverture/cards/p00039-card-couverture-controle/p00039-card-couverture-controle.component';
import { P00039CouvertureControleComponent } from './P00039/Couverture/cps/p00039-couverture-controle/p00039-couverture-controle.component';
import { P00039CardPuissanceStatutComponent } from './P00039/Puissance/cards/p00039-card-puissance-statut/p00039-card-puissance-statut.component';
import { P00039InstallationCoffretComponent } from './P00039/Installation/p00039-installation-coffret/p00039-installation-coffret.component';
import { P00039InstallationProjecteurComponent } from './P00039/Installation/p00039-installation-projecteur/p00039-installation-projecteur.component';
import { P00039InstallationCouvertureBassinComponent } from './P00039/Installation/p00039-installation-couverture-bassin/p00039-installation-couverture-bassin.component';

export class P00039Data {
  syncMode: number = 0;

  //Propriete maitre
  maitrePLangue: number = 0;

  maitreITypeAntenneRF: number = 0;

  maitreIInstallationOk: number = 0;

  maitreIResetUsine: number = 0;

  maitreIConfirmationOTA: number = 0;

  maitreSCompteurResetUsine: number = 0;

  maitreSTemperaturePuce: number = 0;

  maitreSTensionPile: number = 0;

  maitreSAlarmeTensionPile: number = 0;

  maitreSCompteurReset: number = 0;

  maitreSCompteurCoupureAlimentation: number = 0;

  //Propriete eclairage
  eclairageStandardCModeFonctionnement: number = 0;

  eclairageStandardCDemarrageMinuterie: number = 1;

  eclairageStandardCProgrammeSuivant: number = 0;

  eclairageStandardCSynchronisationProgramme: number = 0;

  eclairageStandardCResetUsine: number = 0;

  eclairageStandardPHorlogeJour: string =
    '000000000000000000000000000000000000000000000000000000000000000000000000000000000000';

  eclairageStandardPHorlogeSemaine: string = '000000000000';

  eclairageStandardPHorlogeType: number = 1;

  eclairageStandardPDureeMinuterie: number = 7200;

  eclairageStandardPHeureExtinction: number = 5075;

  eclairageStandardPVoletDeReference: number = 0;

  eclairageStandardPActivationExtinction: number = 0;

  eclairageStandardPActivationExtinction24h: number = 0;

  eclairageStandardPActivationRedemarrageEclairage: number = 0;

  eclairageStandardPActivationFonctionVolet: number = 0;

  eclairageStandardPCodeProgrammeWeltico: number = 0;

  eclairageStandardPHorlogeWelticoSemaine: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourLundi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourMardi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourMercredi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourJeudi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourVendredi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourSamedi: string =
    '000000000000000000000000000000000000000000000000';
  eclairageStandardPHorlogeWelticoJourDimanche: string =
    '000000000000000000000000000000000000000000000000';

  eclairageStandardIDureeRuptureAlimentation: number = 0;

  eclairageStandardITypeEclairage: number = 0;

  eclairageStandardSCommandeEclairage: number = 0;

  eclairageStandardSArretEclairageParMinuterie: number = 0;

  eclairageStandardSArretEclairageParExtinctionAuto: number = 0;

  eclairageStandardSArretEclairageParExtinction24h: number = 0;

  eclairageStandardSArretEclairageParFonctionVolet: number = 0;

  eclairageStandardSCompteAReboursMinuterie: number = 65205;

  eclairageStandardSCompteAReboursExtinction24h: number = 0;

  eclairageStandardSCompteurResetUsine: number = 0;

  //Réseau Zigbee
  reseauZBCRestitutionPanID: number = 0;

  reseauZBCRestitutionRadioPower: number = 0;

  reseauZBCRestitutionRadioChannel: number = 0;

  reseauZBCRestitutionEUI64: string = '0000000000000000';

  reseauZBCRestitutionGlobalKey: string = '00000000000000000000000000000000';

  reseauZBCRestitutionGlobalFrameCounter: number = 0;

  reseauZBCRestitutionNetworkKey: string = '00000000000000000000000000000000';

  reseauZBCRestitutionNetworkFrameCounter: number = 0;

  reseauZBCRestitutionNetworkKeySequenceNumber: number = 0;

  reseauZBCRestitutionExtendedPANID: string = '0000000000000000';

  reseauZBSPanID: number = 0;

  reseauZBSRadioPower: number = 0;

  reseauZBSRadioChannel: number = 0;

  reseauZBSEUI64: string = '0000000000000000';

  reseauZBSGlobalKey: string = '00000000000000000000000000000000';

  reseauZBSGlobalFrameCounter: number = 0;

  reseauZBSNetworkKey: string = '00000000000000000000000000000000';

  reseauZBSNetworkFrameCounter: number = 0;

  reseauZBSNetworkKeySequenceNumber: number = 0;

  reseauZBSExtendedPANID: string = '0000000000000000';

  reseauZBSEtatNetwork: number = 0;

  //Device Table
  deviceTableCProduitAAssocier: number = 0;

  deviceTableCProduitADesassocier: number = 0;

  deviceTableCNodeIdProduitASupprimer: number = 0;

  deviceTableCAnnulerDernierCommisionning: number = 0;

  deviceTableSModeJoignable: number = 0;

  deviceTableSNodeIdProduitEntrant: number = 0;

  deviceTableSErreurDernierAjout: number = 0;

  deviceTableSManufacturerName: string = '';

  deviceTableSPuissanceActive: number = 0;

  deviceTableSPuissanceApparenteTotal: number = 0;

  //Couverture manuelle
  couvertureManuelleIPresenceCouverture: number = 1;

  couvertureManuelleCEtatVolet: number = 1;

  couvertureManuelleCResetUsine: number = 0;

  couvertureManuelleSEtatVolet: number = 1;

  //Settings
  settingsResetAll: number = 0;

  settingsSaveAll: number = 0;

  //Maj
  majTauxAvancementVerifyAndExtractMetadata: number = 50;

  majEtatCourant: number = -1;
}

export class P00039 extends IMaster {
  getUpdateTuto(): ProductTuto {
    throw new Error('Method not implemented.');
  }

  override deviceTableIndex: number = 0;

  override dataIdentifier?: string = 'master';

  override modelIdentifier?: string = 'P00039';

  override manufacturerName?: string = 'ACWA';

  override deviceTable: any = null;

  data: P00039Data = new P00039Data();

  constructor() {
    super();

    this.deviceTable = {
      syncMode: 0,
    };
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P00039;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  resetAddProduct() {
    return [
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCAnnulerDernierCommisionning',
        value: 1,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitAAssocier',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitADesassocier',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCNodeIdProduitASupprimer',
        value: 0,
      },
    ];
  }

  addProduct(pool: Pool, product: IProduct) {
    return [
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCAnnulerDernierCommisionning',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitAAssocier',
        value: product.deviceTableIndex,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitADesassocier',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCNodeIdProduitASupprimer',
        value: 0,
      },
    ];
  }

  saveAll() {
    return {
      index: P00039DataRxTxIndex.Maitre_Settings,
      key: 'settingsSaveAll',
      value: 1,
    };
  }

  hasProduct(pool: Pool, product: IProduct): number {
    if (
      pool?.deviceTable?.master?.deviceTable[
        product!.modelIdentifier!.replace('-', '')
      ] &&
      pool?.deviceTable?.master?.deviceTable[
        product!.modelIdentifier!.replace('-', '')
      ].presenceProduit !== 0 &&
      pool?.deviceTable[product.dataIdentifier!]
    ) {
      return pool?.deviceTable?.master?.deviceTable[
        product!.modelIdentifier!.replace('-', '')
      ].presenceProduit;
    }

    return 0;
  }

  hasAlarm(): boolean {
    return false;
  }

  hasConnect(pool: Pool) {
    return this.hasProduct(pool, new P00045()) !== 0;
  }

  removeProduct(pool: Pool, product: IProduct) {
    return [
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCAnnulerDernierCommisionning',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitAAssocier',
        value: 0,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCProduitADesassocier',
        value: product.deviceTableIndex,
      },
      {
        index: P00039DataRxTxIndex.DeviceTable_Controle,
        key: 'deviceTableCNodeIdProduitASupprimer',
        value: 0,
      },
    ];
  }

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00039/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00039/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00039/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getManager(): IMasterSync {
    return new P00039Sync();
  }

  getProductTuto(): ProductTuto {
    return {};
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00039InstallationCoffretComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00039InstallationProjecteurComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00039InstallationCouvertureBassinComponent,
            condition: (pool: Pool) => {
              return (
                new P00039().hasProduct(pool, new P00041()) == 0 ||
                new P00039().hasProduct(pool, new P00042()) == 0
              );
            },
          },
        ],
        finish: P00039InstallationFinish,
        reset: P00039InstallationReset,
      },

      statusCards: [
        { component: P00039CardPuissanceStatutComponent, weight: 1 },
        { component: P00039CardEclairageStatutComponent, weight: 10 },
        { component: P00039CardCouvertureStatutComponent, weight: 6 },
      ],

      controlCards: [
        { component: P00039CardEclairageControleComponent, weight: 1 },
        { component: P00039CardCouvertureControleComponent, weight: 3 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [
      EventProductFunctionnalityEnum.LIGHTING,
      EventProductFunctionnalityEnum.MASTER,
      EventProductFunctionnalityEnum.COVER,
    ];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (functionnality == EventProductFunctionnalityEnum.MASTER) {
      return {
        controle: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        parametrages: {
          enabledUser: false,
          enabledSupport: false,

          reglage: {
            enabledUser: false,
            enabledSupport: false,
            component: null,
          },
        },
        status: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,
          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00039.couverture.historique.suivi.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'deviceTableSPuissanceApparenteTotal',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 10000 },
                chartMode: HistoryChartModeEnum.NORMAL,
                showDirectly: false,
              },
            ],
          },
        },
      };
    } else if (
      functionnality == IProductFunctionnality.COUVERTURE ||
      functionnality == EventProductFunctionnalityEnum.COVER
    ) {
      return {
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00039CouvertureControleComponent,
        },
        parametrages: {
          enabledUser: false,
          enabledSupport: false,

          reglage: {
            enabledUser: false,
            enabledSupport: false,
            component: null,
          },
        },
        status: {
          enabledUser: false,
          enabledSupport: false,
          component: null,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00039.couverture.historique.suivi.couvertureBassin',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 237,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'couvertureManuelleSEtatVolet',
                valueToMatch: 0,
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
                showDirectly: true,
              },
            ],
          },
        },
      };
    } else if (
      functionnality == IProductFunctionnality.ECLAIRAGE ||
      functionnality == EventProductFunctionnalityEnum.LIGHTING
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00039EclairageMiseEnOeuvreProgEclairageComponent,
              condition: (pool) => {
                return new P00039().hasProduct(pool, new P00031()) == 0;
              },
            },
            {
              component: P00039EclairageMiseEnOeuvreAutomatismeComponent,
              condition: (pool) => {
                return new P00039().hasProduct(pool, new P00031()) == 0;
              },
            },
          ],
          init: P00039EclairageMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00039EclairageControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,
          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00039EclairageParametersSettingsComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00039EclairageStatusComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00039.eclairage.historique.suivi.commandeeclairage',
                mode: HistoryGraphModeEnum.EVENT,
                property: 'eclairageStandardSCommandeEclairage',
                codeEvent: 87,
                yMode: HistoryGraphYModeEnum.HOUR,
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
                showDirectly: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Maitre_Installation,
      propertyName: 'maitreIConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).maitreIInstallationOk !== 1;
  }

  restaurationConfiguration(): RestaurationConfiguration[] {
    return [
      {
        sourceIndex: P00039DataRxTxIndex.ZB_Status,
        destinationIndex: P00039DataRxTxIndex.ZB_Controle,
      },
      {
        sourceIndex: P00039DataRxTxIndex.ZB_Status2,
        destinationIndex: P00039DataRxTxIndex.ZB_Controle2,
      },
    ];
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_3.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_3.csv'
    );
  }
}
